export default "__VITE_ASSET__SUFDbP57__"